import fetch from "@lib/fetch";
import { API } from "../../config";
import { WALLET } from "./_ActionTypes";
import axios from "axios";

export const getWallet = (token) => {
    return async dispatch => {
        dispatch(walletLoading());
        const res = await axios.get(`${API}/v1/wallets`, {
            mode: 'cors',
            method: "POST",
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`
            }
        });
        if(res.data.success) {
            dispatch(fetchWalletSuccess(res.data))
        } else {
            dispatch(fetchWalletFailed(res.data))
        }
    }
};

const walletLoading = () => {
    return {
        type: WALLET.LOADING,
    };
};


const fetchWalletSuccess = data => {
    return {
        type: WALLET.FETCH_SUCCESS,
        data
    };
};

const fetchWalletFailed = error => {
    return {
        type: WALLET.FETCH_FAILED,
        error
    };
};


export const getTransaction = (token,start,end) => {
    let dates = "";
    if (start) {
        dates = `start_date=${start}&end_date=${end}`
    };
    return fetch(`${API}/v1/transactions?${dates}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    });
};

export const topUpWallet = (token, amount) => {
    let newAmount = parseInt(amount);
    return fetch(`${API}/v1/wallets/topups`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            amount:newAmount,
            payment_method:'qris'
        })
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    });
};

export const postpaidRequest = (token, userId) => {
    return fetch(`${API}/v1/wallets/request`,{
        mode: 'cors',
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({userId, request:true})
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};

